import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { isStringEmpty } from '@common/helpers';
import {
  PassengerServiceSupportMap,
  ServiceSupport,
  SpecialServiceRequest,
} from '@common/interfaces/mybooking/order-services.interface';
import { ServicingCommonStoreService } from '@common/services';
import { MyBookingServiceService } from '@common/services/my-booking/my-booking-service/my-booking-service.service';
import { SupportModalBlockComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';
import { Subscription } from 'rxjs';
import { GetOrderResponseData, Traveler } from 'src/sdk-servicing';

@Component({
  selector: 'asw-consideration-support-details-modal',
  templateUrl: './consideration-support-details-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConsiderationSupportDetailsModalComponent extends SupportModalBlockComponent {
  private _subscriptions: Subscription = new Subscription();
  pnr?: GetOrderResponseData;
  supportPassengerInforList!: Array<Traveler>;
  constructor(
    private _common: CommonLibService,
    private _router: Router,
    private _changeDetectorRef: ChangeDetectorRef,
    private readonly _myBookingServiceService: MyBookingServiceService,
    private _servicingCommonStoreService: ServicingCommonStoreService
  ) {
    super(_common);
    this.closeWithUrlChange(this._router);
  }

  init(): void {
    // [14.2] 配慮系サポート情報申込詳細
    // 1.イベントID(1)で取得した配慮系サポート搭乗者情報リストの繰り返し(それぞれ要素が当該搭乗者情報)、以下の通りに、設定する
    this._subscriptions.add(
      this._myBookingServiceService.mybookingServiceState$.subscribe((state) => {
        this.pnr = state?.pnr ?? ({} as GetOrderResponseData);
        this.supportPassengerInforList = state?.supportPassengerInforList ?? [];
        this._changeDetectorRef.markForCheck();
      })
    );
  }

  refresh(): void {}

  destroy(): void {
    if (this._subscriptions) {
      this._subscriptions.unsubscribe();
    }
  }

  reload(): void {}

  // (17)「閉じる」ボタン押下処理(配慮系サポート詳細モーダル)
  closeModalEvent(): void {
    this.close();
  }

  // [14.3] 搭乗者姓名
  getTravelerName(traveler?: Traveler): string {
    return this._myBookingServiceService.getTravelerName(traveler?.names);
  }

  // [14.4] 同伴搭乗者姓名
  getAccompanyingTraveler(traveler?: Traveler): string {
    return this._myBookingServiceService.getAccompanyingTraveler(traveler);
  }

  // [14.4] 同伴搭乗者姓名
  isAccompanyingTravelerForSpecialBaggage(travelerInfo: Traveler): boolean {
    return Boolean(travelerInfo?.accompanyingTravelerId);
  }

  // [14.5] 配慮系サポート詳細
  getSpecialServiceRequest(travelerId?: string) {
    const serviceSupport = this.pnr?.services?.serviceSupport as ServiceSupport;
    return serviceSupport?.[String(travelerId)]?.specialServiceRequests ?? [];
  }

  // [14.6] 配慮系サポート内容
  considerationSupportContent(specialService?: SpecialServiceRequest): string {
    return this._myBookingServiceService.onHandleCommonNo10(specialService?.code);
  }

  // [14.7] ステータス
  getConsiderationSupportInforRegistrationStatus(specialService?: PassengerServiceSupportMap): string {
    const serviceStatus = specialService?.serviceStatus;
    switch (serviceStatus) {
      // [14.1.1] 当該specialServiceRequests.serviceStatus=”confirmed”の場合、申込済みの旨
      case SpecialServiceRequest.ServiceRequestStatusEnum.Confirmed:
        return 'label.applied';

      // [14.1.2] 当該specialServiceRequests.serviceStatus=”cancelled”の場合、キャンセルの旨
      case SpecialServiceRequest.ServiceRequestStatusEnum.Cancelled:
        return 'label.notApplied';

      // [14.1.3] 当該specialServiceRequests.serviceStatus=”requesting”の場合、リクエスト中の旨
      case SpecialServiceRequest.ServiceRequestStatusEnum.Requesting:
        return 'label.applying';

      default:
        return '';
    }
  }
}
